import { PublicSearchRegisteredPaItem } from "../../interfaces/public-search-registered-pa-item.interface";

export const publicAuthorisedPasFilterPredicate = (data: PublicSearchRegisteredPaItem, filter: string): boolean => {
  const transformedFilter = filter.trim().toLowerCase();

  return (
    data.organisationName.toLowerCase().includes(transformedFilter) ||
    data.erauReference.toLowerCase().includes(transformedFilter)
  );
};
